import React, { Component } from "react";
import { connect } from "react-redux";
import CenteredPaper from "../layouts/CenteredPaper";
import IrqChoiceButtons from "../molecules/IrqChoiceButtons";
import { IrqTitle } from "../molecules/IrqTitle";
import { withSubmissionEffect } from "../util/hocs/withSubmissionEffect";
import ILearn from "../molecules/ILearn";

class IrqPrimaryResidenceView extends Component {
  render() {
    const values = ["Primary", "Secondary", "Rental"];
    return (
      <ILearn content={this.props.content}>
        <CenteredPaper>
          <IrqTitle
            content={this.props.content}
            icon="/img/svg_icons/man_in_front_of_house.svg"
          />
          <IrqChoiceButtons
            content={this.props.content}
            value={this.props.data.occupancyType}
            values={values}
            onChoiceMade={(index) => {
              this.props.customFormEdit("occupancyType", values[index]);
              if (values[index] !== "Primary") {
                this.props.customFormEdit("isVeteran", false);
                this.props.customFormEdit("lookAtVALoans", false);
                this.props.customFormEdit("vaFirstTimeUse", false);
                this.props.customFormEdit("disabledVeteran", false);
              }
              this.props.navigationContext.goNext(
                this.props.navigationsAway.Primary,
                true
              );
            }}
          />
        </CenteredPaper>
      </ILearn>
    );
  }
}

export default withSubmissionEffect(connect()(IrqPrimaryResidenceView));
